import React from 'react';

export const IconGrianaFill = () => (
  <svg
    fill='none'
    height='1rem'
    viewBox='0 0 24 24'
    width='1rem'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M15.3537 22.9329H20.3788V17.8905H15.3537V22.9329ZM7.67361 5.16797H2.64844V10.2143H7.67361V5.16797ZM11.3778 10.2104V5.16797H8.65086V10.2143L11.3778 10.2104ZM2.64844 16.9079H7.67361V11.193H2.64844V16.9079ZM8.65753 16.9079H14.3724V12.8867L13.945 13.0371C12.5016 13.5431 11.3791 13.1091 11.3791 11.4154V11.1984H8.65225V16.9132L8.65753 16.9079ZM15.355 16.9079H20.3801V11.8601H20.2191H17.3031L15.3537 12.5432V16.9079H15.355ZM8.65753 22.9329H14.3724V17.8905H8.65753V22.9329Z'
      fill='#495057'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M14.0555 1.33569H20.2258C20.6748 1.33639 21.1052 1.51509 21.4226 1.83257C21.7401 2.15004 21.9187 2.58044 21.9194 3.02941V9.19828C21.9177 9.64693 21.7387 10.0767 21.4214 10.3939C21.1042 10.7111 20.6744 10.8902 20.2258 10.8919H17.1434L13.6282 12.1143C12.8 12.4032 12.3672 12.3805 12.3672 11.4152V3.02673C12.3689 2.57808 12.548 2.14827 12.8652 1.83102C13.1824 1.51378 13.6123 1.33476 14.0609 1.33301L14.0555 1.33569ZM16.2938 3.19983H17.9875V4.88819H16.2952L16.2938 3.19983ZM16.2938 5.99596H17.9875V9.02785H16.2952L16.2938 5.99596Z'
      fill='#495057'
      fillRule='evenodd'
    />
  </svg>
);
